<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolEventsManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "School Calendar",
                description: "Plan and review dates and activities on the school calendar.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Events",
                description: "Create and manage school events and activities.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Sports",
                description: "Coordinate school sports activities, teams, and schedules.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Competitions",
                description: "Organize competitions and track student participation.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Excursions",
                description: "Plan school trips and manage excursion details.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
